import { GlobalAxios } from "../axios/axios-config";
import {
  IAutomationRecRuleTicketDefDoc,
  INewAutomationRecRuleTicketDefDoc,
} from "../models/automation-rec-rule-ticket-def-doc";
import { IInsuranceRegister } from "../models/insurance-register";

const TICKET_AUT_REC_RULE_TICKET_DEF_DOC =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TicketAutRecRuleTicketDefDoc/";

const INSURANCE_REGISTER_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/InsuranceRegister/CalendarRegister";

export const createTicketAutRecRuleTicketDefDoc = (
  item: INewAutomationRecRuleTicketDefDoc
) => {
  return GlobalAxios.post(TICKET_AUT_REC_RULE_TICKET_DEF_DOC, item);
};

export const getTicketAutRecRuleTicketDefDoc = (id: string) => {
  return GlobalAxios.get<IAutomationRecRuleTicketDefDoc>(
    TICKET_AUT_REC_RULE_TICKET_DEF_DOC + id
  );
};

export const updateTicketAutRecRuleTicketDefDoc = ({
  item,
  id,
}: {
  item: INewAutomationRecRuleTicketDefDoc;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_AUT_REC_RULE_TICKET_DEF_DOC + id, item);
};

export const insuranceRegisterList = (params?: any) => {
  return GlobalAxios.get<IInsuranceRegister[]>(INSURANCE_REGISTER_ROUTE, {
    params: params,
    paramsSerializer: {
      indexes: null,
    },
  });
};
